const openStandsPlanModal = (modal) => {
  if (!modal) return
  modal.hidden = false
  document.body.classList.add("backoffice-stands-plan-modal-open")
  modal.querySelector("[data-stands-plan-close]")?.focus?.()
}

const closeStandsPlanModal = (modal) => {
  if (!modal) return
  modal.hidden = true
  document.body.classList.remove("backoffice-stands-plan-modal-open")
}

export const initBackofficeStandsPlan = () => {
  document.querySelectorAll(".backoffice-stands-plan-host").forEach((host) => {
    if (host.dataset.standsPlanBound === "true") return
    host.dataset.standsPlanBound = "true"

    const modal = host.querySelector("[data-stands-plan-modal]")
    const openBtn = host.querySelector("[data-stands-plan-open]")
    if (!modal || !openBtn) return

    openBtn.addEventListener("click", (event) => {
      event.preventDefault()
      openStandsPlanModal(modal)
    })

    modal.querySelectorAll("[data-stands-plan-close]").forEach((el) => {
      el.addEventListener("click", (event) => {
        event.preventDefault()
        closeStandsPlanModal(modal)
      })
    })
  })

  if (document.documentElement.dataset.standsPlanEscBound === "true") return
  document.documentElement.dataset.standsPlanEscBound = "true"

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return
    document.querySelectorAll("[data-stands-plan-modal]:not([hidden])").forEach((modal) => {
      closeStandsPlanModal(modal)
    })
  })
}
